import Grid from "@mui/material/Grid";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import noTest from "../../assets/img/noTest.svg";
import CrmHelpButton from "../Buttons/CrmHelpButton";
import makeStyles from "@mui/styles/makeStyles";
import styles from '../../assets/jss/Scan/scanStyle';

const useStyles = makeStyles(styles);

const NoScanData = () => {
    const classes = useStyles()
    return(
        <Grid className={classes.rootContainer} container>
            <Grid item className={classes.root} xs={12}>
                <ErrorOutlineIcon
                    style={{color: '#753cbe', fontSize: '45px'}}
                />
            </Grid>
            <Grid item className={classes.root} xs={12}>
                <img src={noTest} style={{height: '100px', width: '100px', marginTop: '50px'}}
                />
            </Grid>
            <Grid item xs={12} display={'flex'} textAlign={'center'} justifyContent='center' mt='35px'>
                <p className={classes.noData}>
                    در حال حاضر این دستگاه دارای <br/> هیچ تست قند خونی نمی باشد.</p>
            </Grid>
            <Grid item xs={12} display={'flex'} textAlign={'center'} justifyContent='flex-start' mt='19px'>
                <p className={classes.noDataDes}>
                    پس از انجام تست قند خون، <br/> دستگاه را دوباره اسکن کنید
                </p>
            </Grid>
            <Grid item mt='28px'>
                <CrmHelpButton text={true}/>
            </Grid>
        </Grid>

    )
}
export default NoScanData